<template lang="html">
<div class="map-draw">

    <div
        id="map-draw-button"
        class="mapboxgl-ctrl mapboxgl-ctrl-group map-draw-control"
        @click="togglePolygon">
        <v-tooltip right>
            <button type="button" slot="activator">
                <v-icon class="mbgl-color">crop_free</v-icon>
            </button>
            <span>Bulk Download</span>
        </v-tooltip>
    </div>

</div>
</template>

<script>
import axios from 'axios';
import fileDownload from 'js-file-download';
import MapboxDraw from '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw';
import * as mutations from '@/constants/mutations';

import mapPromiseMixin from '@/mixins/map';

export default {
    mounted() {
        this.addDrawMode();
    },
    mixins: [
        mapPromiseMixin,
    ],
    data() {
        return {
            draw: null,
            currentMode: 'simple_select',
        };
    },
    methods: {
        async addDrawMode() {
            const map = await this.mapPromise;
            this.draw = new MapboxDraw({
                displayControlsDefault: false,
                controls: {},
            });
            map.on('draw.modechange', async () => {
                const geojson = JSON.stringify(this.draw.getAll().features[0].geometry);
                this.draw.deleteAll();
                const { data: file } = await axios.post(`${this.$cfg.API_URL}/licences/lasso.csv`, {
                    geojson,
                }, {
                    responseType: 'blob',
                });
                fileDownload(file, `bulk-${Date.now()}.csv`);
                this.$store.commit(mutations.SET_POLYGON_SELECTING, false);
            });
            map.addControl(this.draw);
        },
        togglePolygon() {
            if (this.currentMode === 'simple_select') {
                this.currentMode = 'draw_polygon';
            } else {
                this.currentMode = 'simple_select';
            }
            this.draw.changeMode(this.currentMode);
            this.$store.commit(mutations.SET_POLYGON_SELECTING, this.currentMode === 'draw_polygon');
        },
    },
};
</script>

<style lang="scss">
.map-draw {
    > div {
        position: absolute;
        top: 160px;
        left: 10px;
    }

    .mbgl-color {
        color: #333;
    }

    .map-draw-control {
        button {
            height: 30px;
            width: 30px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/MapDraw.vue